import { render, staticRenderFns } from "./worktableErpPreviewPage.vue?vue&type=template&id=58a5b5e6&scoped=true&"
import script from "./worktableErpPreviewPage.vue?vue&type=script&lang=tsx&"
export * from "./worktableErpPreviewPage.vue?vue&type=script&lang=tsx&"
import style0 from "./worktableErpPreviewPage.vue?vue&type=style&index=0&id=58a5b5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5b5e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a5b5e6')) {
      api.createRecord('58a5b5e6', component.options)
    } else {
      api.reload('58a5b5e6', component.options)
    }
    module.hot.accept("./worktableErpPreviewPage.vue?vue&type=template&id=58a5b5e6&scoped=true&", function () {
      api.rerender('58a5b5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingDemoPages/worktableErpPreviewPage.vue"
export default component.exports